import styled from 'react-emotion';
import BaseFab from '@material-ui/core/Fab';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Fab = styled(BaseFab)`
  position: absolute;
  z-index: 151;
  right: 16px;
  bottom: 16px;
  height: 42px;
  width: 42px;
  background-color: white;
  color: ${colors.grayDark};
`;
